import { goBack } from 'redux-first-history'

export default function goBackRouterAction () {
  return goBack(...arguments)
}
